/* eslint-disable */
import React, { useState } from "react";
import { Link, withRouter } from "react-router-dom";
import { useForm, Controller } from "react-hook-form";
import { yupResolver } from "@hookform/resolvers/yup";
import * as yup from "yup";
import axios from "axios";
import { emailrgx } from "../assets/constant";
import { logo } from "../_components/Imagepath";
 

const api = axios.create({
  baseURL: process.env.REACT_APP_API_URL,
  timeout: 15000,
  headers: {
    "Content-Type": "application/json",
  },
});
 

const schema = yup.object({
  email: yup
    .string()
    .matches(emailrgx, "Invalid email format")
    .required("Email is required"),
  password: yup
    .string()
    .min(6, "Password must be at least 6 characters")
    .required("Password is required"),
});
 
const Login = (props) => {
  const [eye, setEye] = useState(true);
  const [loading, setLoading] = useState(false);
 
  const {
    handleSubmit,
    control,
    formState: { errors },
  } = useForm({
    resolver: yupResolver(schema),
    defaultValues: { email: "", password: "" },
  });
 

  const onSubmit = async (data) => {
    setLoading(true);
    try {
      const res = await api.post("/api/companies/login", {
        email: data.email,
        password: data.password,
      });
 
      if (res.data?.success) {
  localStorage.setItem("company", JSON.stringify(res.data.company));

  alert("✅ Login successful");

  window.location.replace("/index");
}
 else {
        alert("❌ Login failed");
      }
    } catch (err) {
      if (!err.response) {
        alert("❌ Network error. Please check your connection.");
      } else {
        alert(
          err.response?.data?.message ||
          "❌ Invalid email or password"
        );
      }
    } finally {
      setLoading(false);
    }
  };
 
  return (
    
    <div className="main-wrapper login-body">
            
      <style>{`
      .main-wrapper.login-body {
        min-height: 100vh;
        background: #f4f6fb;
        display: flex;
        align-items: center;
        justify-content: center;
      }
 
      .login-wrapper .container {
        max-width: 100% !important;
        width: 100% !important;
        padding: 10px !important;
      }
 
      .loginbox {
        width: 100% !important;
        max-width: 420px !important;
        margin: auto !important;
        background: #fff;
        border-radius: 14px;
        box-shadow: 0 10px 25px rgba(0,0,0,0.08);
        padding: 30px !important;
      }
 
      .login-right,
      .login-right-wrap {
        width: 100% !important;
      }
 
      .logo-dark {
        display: block;
        margin: 0 auto 20px;
        max-width: 150px;
      }
 
      .pass-group {
        position: relative;
      }
 
      .toggle-password {
        position: absolute;
        right: 12px;
        top: 50%;
        transform: translateY(-50%);
        cursor: pointer;
      }
 
      @media (max-width: 768px) {
        .loginbox {
          padding: 20px !important;
        }
        h1 {
          font-size: 22px !important;
          text-align: center;
        }
        .account-subtitle {
          text-align: center;
          font-size: 13px;
        }
      }
 
      @media (max-width: 480px) {
        .loginbox {
          padding: 15px !important;
        }
        .btn {
          font-size: 14px;
          padding: 10px;
        }
        label {
          font-size: 13px;
        }
        input.form-control {
          font-size: 14px;
          padding: 10px;
        }
      }
      `}</style>
 
      <div className="login-wrapper">
        <div className="container">
          <img className="img-fluid logo-dark mb-2" src={logo} alt="Logo" />
 
          <div className="loginbox">
            <div className="login-right">
              <div className="login-right-wrap">
                <h1>Login</h1>
                <p className="account-subtitle">Access to dashboard</p>
 
                <form onSubmit={handleSubmit(onSubmit)}>
                  <div className="input-block mb-3">
                    <label>Email</label>
                    <Controller
                      name="email"
                      control={control}
                      render={({ field }) => (
                        <input
                          className="form-control"
                          type="email"
                          {...field}
                        />
                      )}
                    />
                    <small className="text-danger">
                      {errors.email?.message}
                    </small>
                  </div>
 
                  <div className="input-block mb-3 login-eye">
                    <label>Password</label>
                    <Controller
                      name="password"
                      control={control}
                      render={({ field }) => (
                        <div className="pass-group">
                          <input
                            type={eye ? "password" : "text"}
                            className="form-control"
                            {...field}
                          />
                          <span
                            onClick={() => setEye(!eye)}
                            className={`fas toggle-password ${
                              eye ? "fa-eye-slash" : "fa-eye"
                            }`}
                          />
                        </div>
                      )}
                    />
                    <small className="text-danger">
                      {errors.password?.message}
                    </small>
                  </div>
 
                  <button
                    type="submit"
                    className="btn btn-primary w-100"
                    disabled={loading}
                  >
                    {loading ? "Logging in..." : "Login"}
                  </button>
                </form>
 
                <div className="text-center mt-3">
                  Don&apos;t have an account?{" "}
                  <Link to="/register">Register</Link>
                </div>

                <div className="text-center mt-3">
                  <Link to="/forgot-password">Forgot Password</Link>
                </div>
 
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};
 
export default withRouter(Login);